import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imLogin', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/auth/login/login.html'),
        controller: 'LoginController',
        controllerAs: 'LoginCtrl',
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/auth/login/login.component.ts